/**
 * Fallback Unsplash images for destination countries.
 * Used when the backend image_url is unavailable or fails to load.
 * Pattern matches the original hardcoded Unsplash URLs from the destinations page.
 */
const COUNTRY_IMAGES: Record<string, string> = {
  'united-states': 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=600&h=400&fit=crop',
  'france': 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=600&h=400&fit=crop',
  'israel': 'https://images.unsplash.com/photo-1544967082-d9d25d867d66?w=600&h=400&fit=crop',
  'united-kingdom': 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&h=400&fit=crop',
  'spain': 'https://images.unsplash.com/photo-1543783207-ec64e4d95325?w=600&h=400&fit=crop',
  'belgium': 'https://images.unsplash.com/photo-1491557345352-5929e343eb89?w=600&h=400&fit=crop',
  'germany': 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=600&h=400&fit=crop',
  'japan': 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=600&h=400&fit=crop',
  'ireland': 'https://images.unsplash.com/photo-1590089415225-401ed6f9db8e?w=600&h=400&fit=crop',
  'italy': 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=600&h=400&fit=crop',
  'mexico': 'https://images.unsplash.com/photo-1518638150340-f706e86654de?w=600&h=400&fit=crop',
  'united-arab-emirates': 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop',
  'uae': 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop',
  'australia': 'https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?w=600&h=400&fit=crop',
  'brazil': 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=600&h=400&fit=crop',
  'thailand': 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=600&h=400&fit=crop',
  'indonesia': 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=600&h=400&fit=crop',
  'poland': 'https://images.unsplash.com/photo-1519197924294-4ba991a11128?w=600&h=400&fit=crop',
  'russia': 'https://images.unsplash.com/photo-1513326738677-b964603b136d?w=600&h=400&fit=crop',
  'portugal': 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=600&h=400&fit=crop',
  'morocco': 'https://images.unsplash.com/photo-1489749798305-4fea3ae63d43?w=600&h=400&fit=crop',
  'greece': 'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=600&h=400&fit=crop',
  'turkey': 'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=600&h=400&fit=crop',
  'india': 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=600&h=400&fit=crop',
  'south-korea': 'https://images.unsplash.com/photo-1517154421773-0529f29ea451?w=600&h=400&fit=crop',
  'singapore': 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=600&h=400&fit=crop',
  'canada': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=600&h=400&fit=crop',
  'netherlands': 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017?w=600&h=400&fit=crop',
  'switzerland': 'https://images.unsplash.com/photo-1527668752968-14dc70a27c95?w=600&h=400&fit=crop',
  'austria': 'https://images.unsplash.com/photo-1516550893923-42d28e5677af?w=600&h=400&fit=crop',
  'czech-republic': 'https://images.unsplash.com/photo-1519677100203-a0e668c92439?w=600&h=400&fit=crop',
  'hungary': 'https://images.unsplash.com/photo-1541849546-216549ae216d?w=600&h=400&fit=crop',
  'croatia': 'https://images.unsplash.com/photo-1555990793-da11153b2473?w=600&h=400&fit=crop',
  'vietnam': 'https://images.unsplash.com/photo-1528127269322-539801943592?w=600&h=400&fit=crop',
  'new-zealand': 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=600&h=400&fit=crop',
  'egypt': 'https://images.unsplash.com/photo-1553913861-c0fddf2619ee?w=600&h=400&fit=crop',
  'south-africa': 'https://images.unsplash.com/photo-1580060839134-75a5edca2e99?w=600&h=400&fit=crop',
  'kenya': 'https://images.unsplash.com/photo-1489392191049-fc10c97e64b6?w=600&h=400&fit=crop',
  'tanzania': 'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=600&h=400&fit=crop',
  'colombia': 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=600&h=400&fit=crop',
  'argentina': 'https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=600&h=400&fit=crop',
  'peru': 'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=600&h=400&fit=crop',
  'chile': 'https://images.unsplash.com/photo-1478827536114-da961b7f86d2?w=600&h=400&fit=crop',
  'costa-rica': 'https://images.unsplash.com/photo-1580041065738-e72023775cdc?w=600&h=400&fit=crop',
  'iceland': 'https://images.unsplash.com/photo-1504829857797-ddff29c27927?w=600&h=400&fit=crop',
  'norway': 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=600&h=400&fit=crop',
  'sweden': 'https://images.unsplash.com/photo-1509356843151-3e7d96241e11?w=600&h=400&fit=crop',
  'denmark': 'https://images.unsplash.com/photo-1513622470522-26c3c8a854bc?w=600&h=400&fit=crop',
  'finland': 'https://images.unsplash.com/photo-1529154036614-a60975f5c7f5?w=600&h=400&fit=crop',
  'romania': 'https://images.unsplash.com/photo-1585409677983-0f6c41ca9c3b?w=600&h=400&fit=crop',
  'china': 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d?w=600&h=400&fit=crop',
  'philippines': 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=600&h=400&fit=crop',
  'malaysia': 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?w=600&h=400&fit=crop',
  'cambodia': 'https://images.unsplash.com/photo-1539367628448-4bc5c9d171c8?w=600&h=400&fit=crop',
  'sri-lanka': 'https://images.unsplash.com/photo-1586523969990-67c4f3e8f077?w=600&h=400&fit=crop',
  'nepal': 'https://images.unsplash.com/photo-1544735716-392fe2489ffa?w=600&h=400&fit=crop',
  'jordan': 'https://images.unsplash.com/photo-1563492065599-3520f775eeed?w=600&h=400&fit=crop',
  'cuba': 'https://images.unsplash.com/photo-1500759285222-a95626b934cb?w=600&h=400&fit=crop',
  'jamaica': 'https://images.unsplash.com/photo-1580237072617-771c3ecc4a24?w=600&h=400&fit=crop',
  'scotland': 'https://images.unsplash.com/photo-1506377585622-bedcbb5f6c1f?w=600&h=400&fit=crop',
  'ecuador': 'https://images.unsplash.com/photo-1547494879-9274bc56e0ac?w=600&h=400&fit=crop',
  'panama': 'https://images.unsplash.com/photo-1564053489984-317bbd824340?w=600&h=400&fit=crop',
  'rwanda': 'https://images.unsplash.com/photo-1612355770966-39d0a6dccc59?w=600&h=400&fit=crop',
};

const DEFAULT_FALLBACK = 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&h=400&fit=crop';

/**
 * Returns a valid image URL for a country.
 * Uses the backend image_url if it looks valid (not a placeholder CDN domain),
 * otherwise falls back to curated Unsplash images.
 */
export function getCountryImage(countryId: string, backendImageUrl?: string, customImageUrl?: string): string {
  if (customImageUrl) return customImageUrl;

  if (backendImageUrl && !backendImageUrl.includes('cdn.globethrivers.com/destinations')) {
    return backendImageUrl;
  }

  return COUNTRY_IMAGES[countryId] || DEFAULT_FALLBACK;
}

export default COUNTRY_IMAGES;
